"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = require("redux");
const currentWizard = (state = '', action) => {
    switch (action.type) {
        case 'START_OPENING_WIZARD_MODAL':
            return action.stateType;
        case 'FINISH_CLOSING_WIZARD_MODAL':
            return '';
        default:
            return state;
    }
};
const isWizardModalOpen = (state = false, action) => {
    switch (action.type) {
        case 'FINISH_OPENING_WIZARD_MODAL':
            return true;
        case 'FINISH_CLOSING_WIZARD_MODAL':
            return false;
        default:
            return state;
    }
};
const isWizardModalClosing = (state = false, action) => {
    switch (action.type) {
        case 'START_CLOSING_WIZARD_MODAL':
            return true;
        case 'FINISH_CLOSING_WIZARD_MODAL':
            return false;
        default:
            return state;
    }
};
exports.default = redux_1.combineReducers({
    currentWizard,
    isWizardModalOpen,
    isWizardModalClosing,
});
exports.getCurrentWizard = (state) => state.currentWizard;
exports.getIsWizardModalOpen = (state) => state.isWizardModalOpen;
exports.getIsWizardModalClosing = (state) => state.isWizardModalClosing;
